import { redirect } from "@tanstack/react-router";

/** Build a beforeLoad that permanently redirects to another in-app path. */
export function redirectTo(to: string) {
  return () => {
    throw redirect({ to, statusCode: 308 });
  };
}
